module.exports = __webpack_public_path__ + "img/selected3-min.7579edd6.png";